import { BranchesResponseModel } from '@gtpl/shared-models/gtpl';
import { Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { truncate } from 'fs';
import { BranchesService } from './branches.service';
@ApiTags('Branches')
@Controller('Branches')
export class BranchesController {
    constructor(private branchesService: BranchesService){        
    }
    @Post('/getBranches')
    async getBranches(): Promise<BranchesResponseModel> {
      // console.log(stateDto);
      try {
        return await this.branchesService.getBranches();
      } catch (error) {
        throw new BranchesResponseModel(false,11104, 'Something wrong');
      }
    }
}
